import React, { Component } from "react";
import PropTypes from "prop-types"
import styleable from "react-styleable";
import defaultStyle from "./basic-card.style";

/**
 * Card containing header, title, body, and button at bottom
 */
export class BasicCard extends Component {

  render() {
    const { body, buttonText, cardId, header, onButtonClick, title, css } = this.props;

    return(
      <div id={cardId} className={css.cardWrapper}>
        <header className={css.header}>
          <div className={css.headerText}>{header}</div>
        </header>
        <div className={css.content}>
          <div className={css.title}>
            {title}
          </div>
          <div className={css.body}>
            {body}
          </div>
        </div>
        <div className={css.buttonWrapper}>
          <button className={css.button} onClick={e => onButtonClick()}>
            {buttonText}
          </button>
        </div>
      </div>
    );
  }
}

BasicCard.propTypes = {
  /** body text or JSX object */
  body: PropTypes.any,
  /** text for button on card */
  buttonText: PropTypes.string,
  /** id for outermost div */
  cardId: PropTypes.string,
  /** text inside header of card */
  header: PropTypes.string,
  /** executes when button is clicked */
  onButtonClick: PropTypes.func.isRequired,
  /** main title text inside card */
  title: PropTypes.string,

}

export default styleable(defaultStyle) (BasicCard);



// WEBPACK FOOTER //
// src/common/widgets/basic-card.js